import { useRef } from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { IStageGateData } from "../../core/_models"

interface Props {
  gateStats: IStageGateData[]
}

const StageGate = ({ gateStats }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null)

  const scroll = (direction: "left" | "right") => {
    if (!scrollRef.current) return

    const scrollAmount = 300

    scrollRef.current.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    })
  }

  return (
    <div className="stage-wrapper position-relative">

      {/* LEFT BUTTON */}
      <button
        className="btn btn-icon btn-light-primary stage-nav-left d-xl-none"
        onClick={() => scroll("left")}
      >
        <i className="ki-duotone ki-left fs-3"></i>
      </button>

      {/* RIGHT BUTTON */}
      <button
        className="btn btn-icon btn-light-primary stage-nav-right d-xl-none"
        onClick={() => scroll("right")}
      >
        <i className="ki-duotone ki-right fs-3"></i>
      </button>

      {/* SCROLL CONTAINER */}
      <div
        ref={scrollRef}
        className="row flex-nowrap flex-xl-wrap overflow-auto overflow-xl-visible g-5 pb-7 pb-lx-3"
      >
        {gateStats.map((stat) => (
          <div
            key={stat.fipdmgate}
            className="col-6 col-sm-3 col-md-2 col-xl"
          >
            <div className="card shadow-sm rounded-4 text-center px-3 py-5">
              <div>
                <div className="fs-9">
                  ISO 9001
                </div>
                <div className="fs-4 fw-bold mb-3">
                  SG {stat.fipdmgate}
                </div>
              </div>
              <div>
                <div className="fs-9">
                FIDPM (NT. 2019)
                </div>
                <div className="fs-4 fw-bold">
                  SG {stat.sipdmgate}
                </div>
              </div>
              {/* <div className="text-muted">
                Active Projects
              </div> */}
            </div>
            <div className="card shadow-sm rounded-4 text-center px-3 py-5 mt-2">
              <div className="">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip className="custom-tooltip-primary">Projects in this stage</Tooltip>}
                >
                  <span className="fs-3 fw-bold badge bg-primary text-white d-inline-block w-70 rounded cursor-pointer">
                    {stat.total}
                  </span>
                </OverlayTrigger>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StageGate